import { Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { differenceInMonths, differenceInYears } from 'date-fns';

import Stack from '@/contents/General/Stack';
import Typography from '@/contents/General/Typography';
import theme from '@/styles/theme';

const OrangeBoard = styled(Box)`
  padding: 12px ${theme.spacing(2)};
  border-radius: 8px;
  background: #e08f55;
`;
const CampHistory = ({
  startHistory,
  totalCampingDaysNum,
}: {
  startHistory: Date;
  totalCampingDaysNum: number;
}) => {
  return (
    <OrangeBoard>
      <Stack alignCenter between>
        <Typography fontSize={10} fontWeight={700} color="white">
          キャンプ歴
        </Typography>
        <Stack alignEnd>
          <Typography
            fontSize={32}
            fontWeight={900}
            color="white"
            lineHeight={1.1}
          >
            {differenceInYears(new Date(), startHistory)}
          </Typography>
          <Typography fontSize={10} fontWeight={700} color="white">
            年
          </Typography>
          <Typography
            fontSize={32}
            fontWeight={900}
            color="white"
            lineHeight={1.1}
          >
            {differenceInMonths(new Date(), startHistory) % 12}
          </Typography>
          <Typography fontSize={10} fontWeight={700} color="white">
            ヵ月
          </Typography>
        </Stack>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: '#ffffff' }}
        />
        <Typography fontSize={10} fontWeight={700} color="white">
          通算
          <br />
          泊数
        </Typography>
        <Stack alignEnd>
          <Typography
            fontSize={32}
            fontWeight={900}
            color="white"
            lineHeight={1.1}
          >
            {totalCampingDaysNum}
          </Typography>
          <Typography fontSize={10} fontWeight={700} color="white">
            泊
          </Typography>
        </Stack>
      </Stack>
    </OrangeBoard>
  );
};
export default CampHistory;
